export enum GroupTypes {
  public = 'public',
  private = 'private',
  subscription = 'subscription',
}

export enum GroupVisibilities {
  public = 'public',
  hidden = 'hidden',
}

export enum GroupSubscriptionFrequency {
  monthly = 'month',
  annually = 'year',
  oneTime = 'onetime',
}

export enum RequestStatus {
  NewRequest = 'New Request',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  None = 'none',
}
